/** Base commune : re-rendu automatique à chaque changement du journal. */

import { LitElement } from 'lit';
import { store } from './store.js';

/**
 * Rendu dans le **DOM clair**, jamais dans un Shadow DOM.
 *
 * C'est indispensable ici : la feuille de style de l'application est globale
 * (`public/styles.css`) et une feuille du document ne traverse pas la frontière
 * d'un shadow root. Sans cette redéfinition, les composants s'affichent, mais
 * aucun style ne les atteint — page nue, sur toutes les machines.
 */
export class StoreElement extends LitElement {
  private detach: (() => void) | null = null;

  protected override createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  override connectedCallback(): void {
    super.connectedCallback();
    if (this.detach === null) {
      this.detach = store.subscribe(() => this.requestUpdate());
    }
  }

  override disconnectedCallback(): void {
    this.detach?.();
    this.detach = null;
    super.disconnectedCallback();
  }

  protected get store(): typeof store {
    return store;
  }
}
